import {postFormData} from './httpApi';

export function uploads(imgs) {
    let imgFormData = new FormData();
    imgFormData.append('file', imgs); //添加sex键值对
    return postFormData('/uploads',imgFormData)

}